import { Stack } from '@storyofams/react-ui';
import { withStory, WithStoryProps } from '@storyofams/storyblok-toolkit';
import { GetStaticProps, NextPage } from 'next';

import { Seo, Container, Header } from '~components';
import { enhancedStaticProps, withLayout, trackFbPageView, gaViewListItemsEvent } from '~lib';
import { DynamicSections } from '~components/dynamic';
import { ProductsGrid } from '~components/meals';
import { getShopifySdk } from '~lib/shopify/client';
import { useEffect } from 'react';

interface ThemeBoxesPageProps extends WithStoryProps {
  boxes: { edges: Record<string, any>[] };
}

const ThemeBoxesPage: NextPage<ThemeBoxesPageProps> = ({ story, boxes }) => {
  // useEffect(() => {
  //   trackFbPageView('theme-boxes page')
  // }, [])

  useEffect(() => {
    const boxesNodes = boxes.edges.map(el => el.node)
    let items = []

    boxesNodes.forEach(bn => {
      bn.variants.edges.forEach(bnve => {
        items.push({
          item_id: bnve?.node?.sku,
          item_name: bnve?.node?.product?.title,
          item_brand: bnve?.node?.product?.vendor,
          item_variant: bnve?.node?.title,
          price: Number(bnve?.node?.priceV2?.amount),
          quantity: 1
        })
      })
    })

    gaViewListItemsEvent({
      list_name: 'Theme boxes page',
      items
    })
  }, [])

  return (
    <>
      <Seo story={story} />

      {/* <Header
        title={story?.content?.header?.[0]?.text}
        img={story?.content?.header?.[0]?.image}
        textProps={{
          justifyContent: 'center',
          maxWidth: ['100%', '100%'],
          as: 'h1',
        }}
        alignItems="center"
      /> */}

      {/* <Container alignItems="center" space={[8, 15]}>
        <ProductsGrid
          gridTemplateColumns={['1fr', 'repeat(2, 1fr)', 'repeat(3, 1fr)']}
          products={boxes}
          skipPortion
        />
      </Container> */}
      <DynamicSections
        content={{ sections: story?.content?.pageSections }}
        disableFirst
      />
      {/* <Stack space={[8]} flexDirection="column" alignItems={'center'} width="100%">

      </Stack> */}
    </>
  );
};

export default withLayout(withStory(ThemeBoxesPage));

export const getStaticProps: GetStaticProps<ThemeBoxesPageProps> =
  enhancedStaticProps(async ({ sdk, defaultLocale, locale }) => {
    let story = null;
    let notFound = false;

    const { products } = await getShopifySdk(locale).products({
      query: 'tag:is_box AND available_for_sale:true',
      first: 250,
    });

    const themeBoxes = (
      await sdk.themeboxpageItems({
        prefix: `${defaultLocale !== locale ? `${locale}/*` : ''}`,
      })
    ).ThemeboxpageItems?.items;

    try {
      story = (
        await sdk.themeBoxesOverview({
          id: `${defaultLocale !== locale ? `${locale}/` : '/'}theme-boxes`,
          lang: defaultLocale !== locale ? locale : 'default',
        })
      ).ThemeboxoverviewItem;
    } catch (e) {
      notFound = true;
    }

    if (notFound || !story) {
      return {
        props: {
          story: {},
          boxes: {},
        },
        notFound: true,
        revalidate: process.env.NEXT_PUBLIC_ENVIRONMENT === 'development' ? 1 : 60,
      };
    }

    // use story handle instead of shopify
    const boxes = {
      ...products,
      edges: products?.edges
        ?.filter(
          ({ node }) =>
            themeBoxes?.findIndex(
              // @ts-ignore
              ({ content }) =>
                content?.shopifyProduct?.item?.blob?.handle === node.handle,
            ) >= 0,
        )
        .map(({ node }) => ({
          node: {
            ...node,
            handle: themeBoxes.find(
              // @ts-ignore
              ({ content }) =>
                content?.shopifyProduct?.item?.blob?.handle === node.handle,
            )?.slug,
          },
        })),
    };

    return {
      props: {
        story,
        boxes,
      },
      notFound: notFound || !story,
      revalidate: 60,
    };
  });
